<div class="rules-container">
  @if (displayHeader) {
  <div class="header fw-bold mb-3">
    <mwp-text-translate text="Create Password" jsonKey="createPassword" />
  </div>
  }
  @if (passwordForm) {
  <form [formGroup]="passwordForm">
    @if (isDialogBox) {
    <div class="mb-4">
      <mwp-input [form]="passwordForm" labelName="Current Password" nameForControl="currentPassword" inputType="password" autoComplete="current-password" autofill />
    </div>
    }
    <div class="mb-4">
      <mwp-input [form]="passwordForm" labelName="New Password" nameForControl="newPassword" inputType="password" autoComplete="new-password" autofill />
    </div>
    <div class="mb-4">
      <mwp-input [form]="passwordForm" labelName="Confirm Password" nameForControl="confirmPassword" inputType="password" autoComplete="new-password" autofill />
    </div>
    @if (isAgent) {
    <div>
      <mwp-agent-location [form]="passwordForm" nameForRadioControl="agentLocation" />
    </div>
    }
  </form>
  }
  <div class="mb-3 rules-inner-container">
    <div>
      <mat-checkbox [checked]="!passwordForm.get('newPassword').hasError('requireMin')" [disabled]=true>
        <mwp-text-translate text="Minimum length (8)" jsonKey="passwordRule1" />

      </mat-checkbox>
    </div>
    <div>
      <mat-checkbox [checked]="!passwordForm.get('newPassword').hasError('requireMax')" [disabled]=true>
        <mwp-text-translate text="Maximum length (20)" jsonKey="passwordRule2" />

      </mat-checkbox>
    </div>
    <div>
      <mat-checkbox [checked]="!passwordForm.get('newPassword').hasError('requireDigit')" [disabled]=true>
        <mwp-text-translate text="Requires Digit Character (1)" jsonKey="passwordRule3" />

      </mat-checkbox>
    </div>
    <div>
      <mat-checkbox [checked]="!passwordForm.get('newPassword').hasError('requireSpecial')" [disabled]=true>
        <mwp-text-translate text="Requires Special Character (1)" jsonKey="passwordRule4" />

      </mat-checkbox>
    </div>
    <div>
      <mat-checkbox [checked]="!passwordForm.get('confirmPassword').hasError('notMatching')" [disabled]=true>
        <mwp-text-translate text="Passwords Match" jsonKey="passwordRule5" />
      </mat-checkbox>
    </div>
  </div>
  <div class="w-100">
    <div>
      <button class="mwp-button w-100 mb-3" [disabled]="passwordForm.invalid" (click)="submitPassword()">
        <mwp-text-translate text="Submit Password" jsonKey="submitPassword" />
      </button>
    </div>
  </div>
</div>